import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mpj-stepIcon",
  "use": "icon-mpj-stepIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mpj-stepIcon\">\n<circle cx=\"8.5\" cy=\"8\" r=\"7\" fill=\"#447D57\" stroke=\"#0F4220\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol